<template>
  <div v-if="show && buildId" class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h6 class="mb-0 text-primary">
            <i class="fa fa-terminal"></i> {{ tr('Deployment Logs') }} - {{ environment }}
            <span v-if="isLive" class="badge badge-success ml-2 pulse">
              <i class="fa fa-circle"></i> {{ tr('Live') }}
            </span>
          </h6>
          <div>
            <small class="text-muted mr-2">{{ logs.length }} {{ tr('lines') }}</small>
            <button class="btn btn-sm btn-outline-secondary" @click="$emit('close')">
              <i>X</i>
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="bg-dark text-light p-3 logs-container" style="height: 400px; overflow-y: auto; font-family: monospace;" ref="logsContainer">
            <div v-if="logs.length === 0" class="text-center text-muted py-4">
              <i class="fa fa-spinner fa-spin"></i> {{ tr('Waiting for logs...') }}
            </div>
            <div v-for="(log, index) in logs" :key="index" class="log-line mb-1">
              <small class="text-info">{{ formatLogTime(log.timestamp) }}</small>
              <span class="ml-2" :class="getLogMessageClass(log.message)">{{ log.message }}</span>
            </div>
            <div v-if="logs.length > 0" class="text-center py-2">
              <small class="text-muted">
                <i class="fa fa-arrow-down"></i> {{ tr('Logs update automatically') }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'system-logs',
  props: {
    show: { type: Boolean, default: false },
    buildId: { type: [String, Number], default: null },
    environment: { type: String, default: '' },
    isLive: { type: Boolean, default: true },
    logs: { type: Array, default: () => [] }
  },
  watch: {
    logs () {
      this.$nextTick(() => {
        const el = this.$refs.logsContainer
        if (el) el.scrollTop = el.scrollHeight
      })
    }
  },
  methods: {
    tr (key) {
      if (window.tr && typeof window.tr === 'function') return window.tr(key)
      if (this.$t && typeof this.$t === 'function') return this.$t(key)
      return key
    },
    formatLogTime (ts) {
      try { return new Date(ts).toLocaleTimeString() } catch (e) { return ts }
    },
    getLogMessageClass (message) {
      if (!message) return ''
      const msg = String(message).toLowerCase()
      if (msg.includes('error') || msg.includes('failed') || msg.includes('exception')) return 'text-danger'
      if (msg.includes('warning') || msg.includes('warn')) return 'text-warning'
      if (msg.includes('success') || msg.includes('completed') || msg.includes('finished')) return 'text-success'
      if (msg.includes('[container]') || msg.includes('phase')) return 'text-info'
      return 'text-light'
    }
  }
}
</script>

<style scoped>
  .pulse { animation: pulse 1.5s infinite; }
  @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
  .logs-container { border: 1px solid #dee2e6; border-radius: 0.25rem; }
  .logs-container::-webkit-scrollbar { width: 8px; }
  .logs-container::-webkit-scrollbar-track { background: #2c3e50; border-radius: 4px; }
  .logs-container::-webkit-scrollbar-thumb { background: #007bff; border-radius: 4px; }
  .logs-container::-webkit-scrollbar-thumb:hover { background: #0056b3; }
  .log-line { line-height: 1.4; word-wrap: break-word; }
  .log-line:hover { background-color: rgba(255, 255, 255, 0.05); }
</style>
